import { currencies } from 'shared/data/siteSettings';

const getCurrency = (selectedCurrency: string) => {
  const currency = currencies.find((currency) => currency['currency'] === selectedCurrency);
  return currency?.currencyCode;
};

export default getCurrency;
